import { style, styleVariants } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const bubbleBase = style({
  maxWidth: "85%",
  padding: `${primitiveTokens.sizing["2x"]} ${primitiveTokens.sizing["3x"]}`,
  borderRadius: primitiveTokens.radii.md,
  wordBreak: "break-word"
});

export const bubble = styleVariants({
  user: [
    bubbleBase,
    {
      alignSelf: "flex-end",
      backgroundColor:
        semanticThemeTokens.button.primary.default.backgroundColor,
      color: semanticThemeTokens.button.primary.textColor
    }
  ],
  assistant: [
    bubbleBase,
    {
      alignSelf: "flex-start",
      backgroundColor: semanticThemeTokens.input.backgroundColor,
      color: semanticThemeTokens.color.textColor
    }
  ]
});
